<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<button type="button" data-toggle="tooltip" title="Отказ" class="btn btn-default" @click="$router.go(-1)"><i class="fa fa-times"></i></button>
					<button type="button" data-toggle="tooltip" title="Запис" class="btn btn-success" @click="onSubmit()"><i class="fa fa-save"></i></button>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content-->
	<div class="container-fluid" v-if="dataReady">

		<!-- Basic Info -->
		<div class="card col-12">
			<div class="card-block">
				<f-image v-model="book.image" src-default="/network/static/img/default_book.jpg" :width="140" :height="200" :avatar="false"></f-image>

				<f-input v-model="book.title" name="book_title" v-validate="'required'" :errors="errorBag.collect('book_title')">
				</f-input>

				<f-input v-model="book.author" name="book_author" v-validate="'required'" :errors="errorBag.collect('book_author')">
				</f-input>

				<f-textarea v-model="book.description" name="book_description" v-validate="'required'" :errors="errorBag.collect('book_description')" :crows="15">
				</f-textarea>

				<f-input v-model="book.publisher" name="book_publisher" v-validate="'required'" :errors="errorBag.collect('book_publisher')">
				</f-input>

				<f-category v-model="book.categories" name="book_categories" v-validate="'required'" :errors="errorBag.collect('book_categories')">
				</f-category>

				<f-select v-model="book.language" name="book_language" v-validate="'required'" :errors="errorBag.collect('book_language')" :values="$config.lists.languages">
				</f-select>

			</div>
			<!-- end card-block -->
		</div>
		<!-- end card -->
	</div>

</div>
</template>

<script>
module.exports = {
	properties: ['id'],
	data: function() {
		return {
			dataReady: true,
			book: {}
		};
	},
	created: function() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function() {
			if (!this.$route.params.id) {
				this.book = {
					title: '',
					description: '',
					categories: '',
					language: 'BG',
					author: '',
					publisher: '',
					image: '', // TODO
					status: 'available'
				};
				this.dataReady = true;
			} else {
				this.$http.get('backend://book/' + this.$route.params.id).then((result) => {
					this.book = result.body;
					this.dataReady = true;
				}).catch(this.$http.toastCatcher);
			}
		},
		onSubmit: function() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					this.$toasted.show('Моля, оправете грешките във формата').goAway(1500);
					return;
				}
				this.$http.putOrPostResource('backend://book/', this.book).then((response) => {
					this.$router.push('/book/list'); // TODO: Navigate to the book detail page
				}).catch(this.$http.toastCatcher);
			});
		}
	}
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// BookEdit.vue?280a0aa5